





















































































import Vue from "vue";
import { DcmCreateDocument, DcmDocumentListConfig, DcmDocumentListQuery } from "../interfaces/DcmDocumentListConfiguration";
import { DcmService } from "../services";
import { DataOptions, DataTableHeader } from "vuetify";
import DeleteWarning from "../modals/DeleteWarning.vue";
import CreateDocument from "../modals/CreateDocument.vue";

export default Vue.extend({
  props: {
    config: {
      type: Object as () => DcmDocumentListConfig<DcmDocumentListQuery>,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      pagination: {} as DataOptions,
      itemSelected: [],
      loading: true,
      totalElements: 0,
      delay: undefined as any,
    };
  },
  watch: {
    pagination: {
      handler() {
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.refresh();
        }, 500);
      },
      deep: true,
    },
    config: {
      handler() {
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.refresh();
        }, 500);
      },
      deep: true,
    },
  },
  computed: {
    headers(): DataTableHeader[] {
      const headers: DataTableHeader[] = this.config.columns.map(column => {
        return {
          text: this.$tc(column.label),
          value: column.key,
          align: column.align,
          sortable: column.sortable,
          pipe: column.pipe,
        };
      });
      return this.config.actions
        ? [...headers, { text: this.$tc("dcm.actions"), value: "actions", sortable: false }]
        : headers;
    },
    hasMultipleRowAction(): boolean {
      if (
          this.config.actions?.delete?.multipleRows
        ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.items = [];
      this.itemSelected = [];
      
      //Update query
      (this.config.query.orderBy = this.pagination.sortBy.map((sortBy, index) => {
        return { value: sortBy, desc: this.pagination.sortDesc[index] };
      })),
        (this.config.query.limit = this.pagination.itemsPerPage);
      this.config.query.offset = (this.pagination.page - 1) * this.pagination.itemsPerPage;
      //Send request
      const response = await DcmService.search(this.config.query);
      this.items = response.content;
      //TODO: Update paging with totalElemnts.
      this.totalElements = (this.pagination.page-1) * this.pagination.itemsPerPage + response.totalElements;
      
      if (response.hasMoreElements) {
        this.totalElements += 1;
      }
      this.loading = false;
    },
    async deleteSingleDocument(item: any) {
      const confirmed: boolean = await this.$modal.show<boolean>(DeleteWarning, {
        deleteDocuments: [
          typeof this.config.itemName == "function" ? this.config.itemName(item) : item[this.config.itemName],
        ],
      });
      if (confirmed) {
        await this.deleteDocument(item[this.config.itemKey]);
        this.refresh();
      }
    },
    async deleteMultipleDocuments() {
      const confirmed: boolean = await this.$modal.show<boolean>(DeleteWarning, {
        deleteDocuments: this.itemSelected.map(item => {
          return typeof this.config.itemName == "function" ? this.config.itemName(item) : item[this.config.itemName];
        }),
      });
      if (confirmed) {
        for (const item of this.itemSelected) {
          await this.deleteDocument(item[this.config.itemKey]);
        }
        this.itemSelected = [];
        this.refresh();
      }
    },
    async deleteDocument(objectId: string) {
      await DcmService.delete(objectId);
    },
    async downloadDocument(item: any) {
      let uniqueDownload = false;
      if(this.config.actions?.download?.uniqueDownload) {
        uniqueDownload = this.config.actions?.download?.uniqueDownload(item);
      }
      const documentAsBlob = await DcmService.getObjectContentAsBlob(item[this.config.itemKey], uniqueDownload);
      const blob = new Blob([documentAsBlob]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = typeof this.config.itemName == "function" ? this.config.itemName(item) : item[this.config.itemName];
      link.click();
      if(uniqueDownload) {
        this.refresh();
      }
    },
    async createDocument() {
      await this.$modal.show(CreateDocument, JSON.parse(JSON.stringify(this.config.actions?.create?.options)));
      this.refresh();
    },
  },
});
